var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7983 18.2336V18.2328H18.8029V11.4686C18.8029 8.15944 18.0904 5.61035 14.2212 5.61035C12.3612 5.61035 11.113 6.63091 10.6034 7.59844H10.5496V5.91929H6.88098V18.2328H10.701V12.1356C10.701 10.5302 11.0054 8.97789 12.9938 8.97789C14.953 8.97789 14.9822 10.81 14.9822 12.2386V18.2336H18.7983Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27063 6.31152H4.77709V18.2335H1.27063V6.31152Z",
    fill: "#00ADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67321 0C1.51177 0 0.569336 0.938044 0.569336 2.09407C0.569336 3.25009 1.51177 4.20775 2.67321 4.20775C3.83465 4.20775 4.77709 3.25009 4.77709 2.09407C4.77636 0.938044 3.83392 0 2.67321 0Z",
    fill: "#00ADEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinOutline);
export default __webpack_public_path__ + "static/media/linkedinOutline.6c87856507993dd1897af9b8e2f99c4a.svg";
export { ForwardRef as ReactComponent };